export default __webpack_public_path__ + "static/media/ensinio_logo_dark_new.05bf653d.svg";